module.exports = __webpack_public_path__ + "img/contributionsFreeOff.f4fa1daf.svg";